import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QcEvent, QcRecord } from '../../domain/qc.model';

export interface QcExpandedPanelDialogData {
  event: QcEvent;
  collectorName: string;
}

@Component({
  selector: 'app-qc-expanded-panel-dialog',
  templateUrl: './qc-expanded-panel-dialog.component.html',
  styleUrls: ['./qc-expanded-panel-dialog.component.css']
})
export class QcExpandedPanelDialogComponent {
  readonly qcSaved = new EventEmitter<QcRecord>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: QcExpandedPanelDialogData,
    private dialogRef: MatDialogRef<QcExpandedPanelDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  onQcSaved(qc: QcRecord): void {
    this.qcSaved.emit(qc);
  }

  get gameLabel(): string {
    const homeTeam = this.data.event.homeTeam?.trim();
    const awayTeam = this.data.event.awayTeam?.trim();

    if (homeTeam && awayTeam) {
      return `${homeTeam} - ${awayTeam}`;
    }

    return homeTeam || awayTeam || '—';
  }

  get collectorLabel(): string {
    return this.data.collectorName.trim();
  }

  get eventTypeLabel(): string {
    return (
      this.data.event.code?.trim() || this.data.event.dcType?.trim() || '—'
    );
  }
}
